import React, { useState, useMemo } from "react"
import { Input } from "./ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select"
import { AdminOrganization } from "../app/services/meseeknaApiV2"

type OrganizationSelectorProps = {
  organizations: AdminOrganization[]
  selectedOrganizationId: number | null
  onOrganizationChange: (organizationId: number) => void
  placeholder?: string
}

const OrganizationSelector: React.FC<OrganizationSelectorProps> = ({
  organizations,
  selectedOrganizationId,
  onOrganizationChange,
  placeholder = "Select organization...",
}) => {
  const [searchQuery, setSearchQuery] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  const filteredOrganizations = useMemo(() => {
    if (!searchQuery.trim()) {
      return organizations
    }
    const query = searchQuery.toLowerCase()
    return organizations.filter((org) =>
      org.organizationName.toLowerCase().includes(query)
    )
  }, [organizations, searchQuery])

  const selectedOrganization = organizations.find(
    (org) => org.id === selectedOrganizationId
  )

  const handleSelect = (value: string) => {
    const orgId = parseInt(value)
    if (!isNaN(orgId)) {
      onOrganizationChange(orgId)
      setIsOpen(false)
      setSearchQuery("")
    }
  }

  return (
    <div className="relative">
      <Select
        open={isOpen}
        onOpenChange={setIsOpen}
        value={selectedOrganizationId?.toString() || ""}
        onValueChange={handleSelect}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={placeholder}>
            {selectedOrganization?.organizationName || placeholder}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          <div className="sticky top-0 z-10 bg-white p-2 border-b">
            <Input
              placeholder="Search organizations..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => {
                e.stopPropagation()
                if (e.key === "Escape") {
                  setIsOpen(false)
                }
              }}
              className="w-full"
              autoFocus
            />
          </div>
          {filteredOrganizations.length > 0 ? (
            filteredOrganizations.map((org) => (
              <SelectItem key={org.id} value={org.id.toString()}>
                {org.organizationName}
              </SelectItem>
            ))
          ) : (
            <div className="px-2 py-6 text-center text-sm text-gray-500">
              No organizations found
            </div>
          )}
        </SelectContent>
      </Select>
    </div>
  )
}

export default OrganizationSelector





